import React, { Component } from 'react';
import PageHeader from '../../../app/layout/ui/header/PageHeader';
import SubHeader from '../../../app/layout/ui/header/SubHeader';
import ClientForm from '../form';

class CreateClient extends Component {
	render() {
		return (
			<div>
				<PageHeader title="New Client" />
				<SubHeader title="Create a new ReKy client" />

				<div className="page-wrapper">
					<ClientForm isNew />
				</div>
			</div>
		);
	}
}
export default CreateClient;
